module.exports = __webpack_public_path__ + "img/fuwubuzhoueng.70f7053a.png";